import React, { useState } from "react";
import { useLocale } from './LocaleProvider';

async function jsonRequest(path, body) {
  const response = await fetch(path, {
    method: "POST",
    credentials: "same-origin",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload.error || "Não foi possível concluir a operação.");
  return payload;
}

export default function OtpAuth({ onAuthenticated }) {
  const { locale } = useLocale();
  const es = locale === 'es';
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [step, setStep] = useState("email");
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");

  async function sendCode(event) {
    event.preventDefault();
    setBusy(true); setMessage("");
    try {
      await jsonRequest("/api/auth/send-otp", { email });
      setStep("otp");
      setMessage(es ? 'Código enviado. Revisa tu correo electrónico.' : "Código enviado. Confira seu e-mail.");
    } catch (error) { setMessage(es ? 'No fue posible enviar el código. Inténtalo de nuevo.' : error.message); }
    finally { setBusy(false); }
  }

  async function verifyCode(event) {
    event.preventDefault();
    setBusy(true); setMessage("");
    try {
      let attribution = null;
      try { attribution = window.__eidocLastCta || JSON.parse(window.localStorage.getItem('minimental_last_cta') || 'null'); } catch (_) {}
      const attributionProps = attribution && Date.now() - Number(attribution.at || 0) < 86400000
        ? { cta_id: attribution.id, cta_path: attribution.path }
        : {};
      // free_signup_verified é registrado pelo servidor na primeira verificação real do
      // e-mail; o navegador só envia a atribuição do CTA junto com o código.
      const payload = await jsonRequest("/api/auth/verify-otp", { email, otp, ...attributionProps });
      const authenticatedEmail = payload.user?.email || email.trim().toLowerCase();
      const access = await jsonRequest("/api/auth/otp-login-complete", {});
      void fetch("/api/ativar", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: authenticatedEmail }),
        keepalive: true,
      }).catch(() => {});
      if (payload.user?.id) window.eidocAnalytics?.identify(payload.user.id, { product: 'minimental', auth_method: 'otp' });
      window.eidocAnalytics?.capture('otp_login_verified', { auth_method: 'otp', ...attributionProps });
      onAuthenticated?.(payload.user || { email: authenticatedEmail }, access);
    } catch (error) { setMessage(es ? 'No fue posible verificar el código. Revisa el número e inténtalo de nuevo.' : error.message); }
    finally { setBusy(false); }
  }

  return (
    <div>
      {step === "email" ? (
        <form onSubmit={sendCode}>
          <label className="block text-sm font-bold text-[var(--primary)]" htmlFor="otp-email">{es ? 'Correo electrónico' : 'E-mail'}</label>
          <input id="otp-email" required type="email" autoComplete="email" value={email} onChange={(event) => setEmail(event.target.value)} placeholder={es ? 'tu@correo.com' : 'seu@email.com'} className="input-field mt-2" />
          <button data-analytics-event="free_signup_started" disabled={busy} className="mt-4 w-full rounded-xl bg-[var(--accent)] p-3 font-bold text-[var(--on-accent)] disabled:opacity-60">{busy ? (es ? 'Enviando…' : 'Enviando…') : (es ? 'Enviar código por correo' : 'Receber código por e-mail')}</button>
        </form>
      ) : (
        <form onSubmit={verifyCode}>
          <label className="block text-sm font-bold text-[var(--primary)]" htmlFor="otp-code">{es ? 'Código de 6 dígitos' : 'Código de 6 dígitos'}</label>
          <input id="otp-code" required inputMode="numeric" pattern="[0-9]{6}" maxLength={6} autoComplete="one-time-code" value={otp} onChange={(event) => setOtp(event.target.value.replace(/\D/g, "").slice(0, 6))} placeholder="000000" className="input-field mt-2 tracking-[0.3em]" />
          <button data-analytics-event="free_signup_completed" disabled={busy} className="mt-4 w-full rounded-xl bg-[var(--accent)] p-3 font-bold text-[var(--on-accent)] disabled:opacity-60">{busy ? (es ? 'Verificando…' : 'Confirmando…') : (es ? 'Confirmar y acceder gratis' : 'Confirmar e acessar gratuitamente')}</button>
          <button type="button" onClick={() => { setStep("email"); setOtp(""); setMessage(""); }} className="mt-3 w-full text-sm text-[var(--primary)] underline">{es ? 'Usar otro correo' : 'Usar outro e-mail'}</button>
        </form>
      )}
      {message && <p role="status" className="mt-4 text-sm text-[var(--text-muted)]">{message}</p>}
    </div>
  );
}
